module.exports = __webpack_public_path__ + "static/img/wg-card-bg.a51261d8.png";